import { SendTypes } from '../core/api/models';

export class SendTypesUiDto {
  type?: SendTypes;
  colorName?: string;
  color?: string;
  tailwindColor?: string;
  lightColor?: string;
  borderColor?: string;
  icon?: string;
  fadeColor?: string;
}

const styles = getComputedStyle(document.documentElement);

export const SendTypesUi: SendTypesUiDto[] = [
  {
    type: SendTypes.OTP,
    colorName: 'teal',
    color: styles.getPropertyValue('--color-teal'),
    tailwindColor: 'teal-500',
    fadeColor: styles.getPropertyValue('--color-teal-fade'),
    lightColor: styles.getPropertyValue('--color-teal-tint'),
    borderColor: styles.getPropertyValue('--color-teal'),
    icon: 'mdi mdi-code-braces',
  },
  {
    type: SendTypes.Bulk,
    colorName: 'lime',
    color: styles.getPropertyValue('--color-lime'),
    tailwindColor: 'lime-500',
    fadeColor: styles.getPropertyValue('--color-lime-fade'),
    lightColor: styles.getPropertyValue('--color-lime-tint'),
    borderColor: styles.getPropertyValue('--color-lime'),
    icon: 'mdi mdi-comment-text-multiple-outline',
  },
  {
    type: SendTypes.Bulk2,
    colorName: 'navyBlue',
    color: styles.getPropertyValue('--color-navyBlue'),
    tailwindColor: 'indigo-500',
    fadeColor: styles.getPropertyValue('--color-navyBlue-fade'),
    lightColor: styles.getPropertyValue('--color-navyBlue-tint'),
    borderColor: styles.getPropertyValue('--color-navyBlue'),
    icon: 'mdi mdi-comment-text-multiple-outline',
  },
  {
    type: SendTypes.ApiSingle,
    colorName: 'sky',
    color: styles.getPropertyValue('--color-sky'),
    tailwindColor: 'cyan-500',
    fadeColor: styles.getPropertyValue('--color-sky-fade'),
    lightColor: styles.getPropertyValue('--color-sky-tint'),
    borderColor: styles.getPropertyValue('--color-sky'),
    icon: 'mdi mdi-api',
  },
  {
    type: SendTypes.Single,
    colorName: 'success',
    color: styles.getPropertyValue('--color-success'),
    tailwindColor: 'green-500',
    fadeColor: styles.getPropertyValue('--color-success-fade'),
    lightColor: styles.getPropertyValue('--color-success-tint'),
    borderColor: styles.getPropertyValue('--color-success'),
    icon: 'mdi mdi-comment-processing-outline ',
  },
  {
    type: SendTypes.Club,
    colorName: 'pink',
    color: styles.getPropertyValue('--color-pink'),
    tailwindColor: 'pink-500',
    fadeColor: styles.getPropertyValue('--color-pink-fade'),
    lightColor: styles.getPropertyValue('--color-pink-tint'),
    borderColor: styles.getPropertyValue('--color-pink'),
    icon: 'mdi mdi-account-multiple',
  },
  {
    type: SendTypes.Dynamic,
    colorName: 'rose',
    color: styles.getPropertyValue('--color-rose'),
    tailwindColor: 'rose-500',
    fadeColor: styles.getPropertyValue('--color-rose-fade'),
    lightColor: styles.getPropertyValue('--color-rose-tint'),
    borderColor: styles.getPropertyValue('--color-rose'),
    icon: 'mdi mdi-code-brackets',
  },
  {
    type: SendTypes.P2P,
    colorName: 'warning',
    color: styles.getPropertyValue('--color-warning'),
    tailwindColor: 'yellow-500',
    fadeColor: styles.getPropertyValue('--color-warning-fade'),
    lightColor: styles.getPropertyValue('--color-warning-tint'),
    borderColor: styles.getPropertyValue('--color-warning'),
    icon: 'mdi mdi-format-horizontal-align-center',
  },
  {
    type: SendTypes.Phonebook,
    colorName: 'info',
    color: styles.getPropertyValue('--color-info'),
    tailwindColor: 'indigo-500',
    fadeColor: styles.getPropertyValue('--color-info-fade'),
    lightColor: styles.getPropertyValue('--color-info-tint'),
    borderColor: styles.getPropertyValue('--color-info'),
    icon: 'mdi mdi-account-box-multiple-outline',
  },
  {
    type: SendTypes.ApiP2P,
    colorName: 'brown',
    color: styles.getPropertyValue('--color-brown'),
    tailwindColor: 'slate-500',
    fadeColor: styles.getPropertyValue('--color-brown-fade'),
    lightColor: styles.getPropertyValue('--color-brown-tint'),
    borderColor: styles.getPropertyValue('--color-brown'),
    icon: 'mdi mdi-api',
  },
  {
    type: SendTypes.Smart,
    colorName: 'purple',
    color: styles.getPropertyValue('--color-purple'),
    tailwindColor: 'emerald-500',
    fadeColor: styles.getPropertyValue('--color-purple-fade'),
    lightColor: styles.getPropertyValue('--color-purple-tint'),
    borderColor: styles.getPropertyValue('--color-purple'),
    icon: 'mdi mdi-map-marker-radius',
  },
];
